import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import BoxContainer from '../../style-components/BoxContainer.jsx';
import ChatTable from '../../style-components/Tables/ChatTable.jsx';
import { getCurrentUser } from '../../models/user.js';

const ChatList = () => {
  const navigate = useNavigate();

  useEffect(() => {
    getCurrentUser()
      .then(user => {
        if (user.role !== 'TEACHER' && user.role !== 'ADMIN') {
          navigate('/unauthorized');
        }
      })
      .catch();
  }, []);

  return (
    <BoxContainer>
      <ChatTable />
    </BoxContainer>
  );
};

export default ChatList;
